import { useFamily, useUnreadAlertCount } from '@/hooks'
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { MobileNav } from './MobileNav'

interface DashboardLayoutProps {
  unreadAlerts?: number
}

export function DashboardLayout({ unreadAlerts: suppliedCount }: DashboardLayoutProps) {
  const { selectedFamilyId } = useFamily()
  const { data: count } = useUnreadAlertCount(selectedFamilyId)
  const unreadAlerts = suppliedCount ?? count?.unread_count ?? 0
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <div className="flex h-screen bg-canvas">
      {/* Desktop sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-64 lg:flex-col">
        <Sidebar unreadAlerts={unreadAlerts} />
      </div>

      {/* Mobile navigation */}
      <MobileNav
        open={mobileNavOpen}
        onOpenChange={setMobileNavOpen}
        unreadAlerts={unreadAlerts}
      />

      {/* Main content area */}
      <div className="flex flex-1 flex-col lg:pl-64">
        <Header
          unreadAlerts={unreadAlerts}
          showMenuButton
          onMenuClick={() => setMobileNavOpen(true)}
        />

        <main className="hearth-canvas flex-1 overflow-y-auto">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
